import { useEffect } from 'react';
import { cleanupModal } from '../utils/modalUtils';

const useModalEffect = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      cleanupModal(); // remove any stale backdrops first
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    } else {
      cleanupModal();
    }
    return () => cleanupModal();
  }, [isOpen]);
};

export default useModalEffect;
